import markConversationsReadInReadingPaneStore from '../actions/markConversationsReadInReadingPaneStore';
import markConversationsAsReadStoreUpdate from 'owa-mail-actions/lib/triage/markConversationsAsReadStoreUpdate';
import { getFolderIdForParentComparison } from 'owa-mail-list-store';
import { orchestrator } from 'satcheljs';
export default orchestrator(markConversationsAsReadStoreUpdate, function (actionMessage) {
    var conversationIds = actionMessage.conversationIds, tableViewId = actionMessage.tableViewId, isReadValue = actionMessage.isReadValue;
    markConversationsReadInReadingPaneStore(conversationIds, isReadValue, getFolderIdForParentComparison(tableViewId));
});
//# sourceMappingURL=markConversationsAsReadStoreUpdateOrchestrator.js.map